module.exports = __webpack_public_path__ + "images/oos-blue-aea2009a.svg";